import { useState, useEffect } from 'react';
import Menu from '../components/Menu';
import '../css/Home.css';
import { PieChart, Pie, Cell} from "recharts";
import api from '../service/api';

function Home() {
  const [alunos, setAlunos] = useState([]);

  useEffect(() => {
    api.get('/api/user/students', { withCredentials: true })
      .then(res => setAlunos(res.data || []))
      .catch(err => console.error('Erro ao buscar alunos:', err));
  }, []);

  const total = alunos.length;
  // Limite de alunos do personal (definido no cadastro dele; 15 é o padrão do sistema).
  const limiteAlunos = (() => {
    try {
      const usuario = JSON.parse(localStorage.getItem('@AppAcademia:user') || 'null');
      const limite = Number(usuario?.limiteAlunos);
      return Number.isFinite(limite) && limite > 0 ? limite : 15;
    } catch (e) {
      return 15;
    }
  })();

  // ── Dados calculados a partir do backend ─────────────────────────────────

  const pct = (n) => total > 0 ? Math.round((n / total) * 100) : 0;

  const alunosCadastrados = total;

  const dataIdadeAlunos = [
    { name: "Até 18 anos",  value: pct(alunos.filter(a => Number(a.idade) <= 18).length),                              color: "#0088fe" },
    { name: "18 a 35 anos", value: pct(alunos.filter(a => Number(a.idade) > 18 && Number(a.idade) <= 35).length),      color: "#00c49f" },
    { name: "35 a 50 anos", value: pct(alunos.filter(a => Number(a.idade) > 35 && Number(a.idade) <= 50).length),      color: "#ffbb28" },
    { name: "Acima de 50",  value: pct(alunos.filter(a => Number(a.idade) > 50).length),                               color: "#ff4242" },
  ];

  const dataGeneros = [
    { name: "Masculino", value: pct(alunos.filter(a => a.sexo === 'masculino').length), color: "#0088fe" },
    { name: "Feminino",  value: pct(alunos.filter(a => a.sexo === 'feminino').length),  color: "#ff4242" },
  ];

  const dataPerfis = [
    { name: "Adultos",              value: pct(alunos.filter(a => a.profile === 'homensEMulheresAdultos').length),       color: "#0088fe" },
    { name: "Mulheres emag.",       value: pct(alunos.filter(a => a.profile === 'mulheresQueDesejamEmagrecer').length),  color: "#00c49f" },
    { name: "Idosos",               value: pct(alunos.filter(a => a.profile === 'idosos').length),                      color: "#ffbb28" },
    { name: "Gestantes",            value: pct(alunos.filter(a => a.profile === 'gestantes').length),                   color: "#ff4242" },
    { name: "Pós-parto",            value: pct(alunos.filter(a => a.profile === 'posParto').length),                    color: "#66a3ff" },
    { name: "Obesos",               value: pct(alunos.filter(a => a.profile === 'obesos').length),                      color: "#33d1b2" },
    { name: "Diabetes",             value: pct(alunos.filter(a => a.profile === 'diabetesMelitus').length),              color: "#ffd966" },
    { name: "Hipertensão arterial", value: pct(alunos.filter(a => a.profile === 'hipertensaoArterial').length),          color: "#ff7f7f" },
    { name: "Depressão",            value: pct(alunos.filter(a => a.profile === 'depressao').length),                   color: "#a12bff" },
  ];

  // ── Dados de IMC (alunos que já realizaram Antropometria) ───────────────
  const alunosComIMC = alunos.filter(a => a.imc != null);
  const totalIMC = alunosComIMC.length;
  const pctIMC = (n) => totalIMC > 0 ? Math.round((n / totalIMC) * 100) : 0;

  const dataIMC = [
    { name: "Abaixo do peso", value: pctIMC(alunosComIMC.filter(a => Number(a.imc) < 18.5).length),                                  color: "#66a3ff" },
    { name: "Peso normal",    value: pctIMC(alunosComIMC.filter(a => Number(a.imc) >= 18.5 && Number(a.imc) <= 24.9).length),         color: "#00c49f" },
    { name: "Sobrepeso",      value: pctIMC(alunosComIMC.filter(a => Number(a.imc) >= 25   && Number(a.imc) <= 29.9).length),         color: "#ffbb28" },
    { name: "Obeso",          value: pctIMC(alunosComIMC.filter(a => Number(a.imc) >= 30).length),                                   color: "#ff4242" },
  ];

  // ─────────────────────────────────────────────────────────────────────────

  const vagasRestantes = Math.max(0, limiteAlunos - alunosCadastrados);

  const dataAlunos = [
    { name: "Alunos cadastrados", value: alunosCadastrados, color: "#ffbb28", corRotulo: "#1e1f21" },
    { name: "Vagas restantes",    value: vagasRestantes,    color: "#4c4c4c", corRotulo: "#ffffff" },
  ];

  // Valor de cada fatia escrito dentro do próprio anel do gráfico.
  const rotuloDentroDaFatia = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }) => {
    if (!value) return null;
    const raio = innerRadius + (outerRadius - innerRadius) / 2;
    const angulo = -midAngle * (Math.PI / 180);
    return (
      <text
        x={cx + raio * Math.cos(angulo)}
        y={cy + raio * Math.sin(angulo)}
        fill={dataAlunos[index]?.corRotulo || "#fff"}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={15}
        fontWeight="bold"
      >
        {value}
      </text>
    );
  };

  const GraficoBarraSimples = ({ dados, largura = '180px' }) => {
    const todosZero = dados.every(item => !item.value);

    if (todosZero) {
      return (
        <div
          style={{
            display: 'flex',
            height: '30px',
            width: largura,
            borderRadius: '2px',
            overflow: 'hidden',
            boxShadow: '0 0 4px rgba(0,0,0,0.1)',
            backgroundColor: '#4c4c4c',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
            fontSize: '11px',
          }}
        >
          Sem dados
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          height: '30px',
          width: largura,
          borderRadius: '2px',
          overflow: 'hidden',
          boxShadow: '0 0 4px rgba(0,0,0,0.1)',
        }}
      >
        {dados.map((item, index) => (
          <div
            key={index}
            style={{
              flex: item.value || 0.01,
              backgroundColor: item.color,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '10px',
              color: '#fff',
              whiteSpace: 'nowrap',
            }}
            title={`${item.name} - ${item.value}%`}
          >
            {item.value > 10 ? `${item.value}%` : ''}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <Menu isHome={true}/>
      <div className="avaliacao-container">
        <div className="avaliacao-content flex-row">
          <div className="home-left-content">
            <p className="home-titles">Alunos cadastrados no sistema</p>
            <PieChart width={200} height={200}>
              <Pie
                data={dataAlunos}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                startAngle={90}
                endAngle={90 + 360}
                dataKey="value"
                stroke="none"
                label={rotuloDentroDaFatia}
                labelLine={false}
              >
                {dataAlunos.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color}/>
                ))}
              </Pie>
            </PieChart>
            <div className="legend pad-top-10">
              <div className="legend-item">
                <span className="legend-color" style={{ backgroundColor: "#ffbb28" }}></span>
                Alunos cadastrados : {alunosCadastrados}
              </div>
              <div className="legend-item">
                <span className="legend-color" style={{ backgroundColor: "#4c4c4c" }}></span>
                Limite de alunos : {limiteAlunos}
              </div>
            </div>
          </div>

          <div className="home-right-content">
          <p className="home-titles est-data">Dados estatísticos do sistema</p>
            <div className="grid-container">
              {/* Idade dos alunos */}
              <div className="grid-item grid-item-border">
                <p className="home-titles-style-2">Idade</p>
                <GraficoBarraSimples dados={dataIdadeAlunos} />
                <div className="legend">
                  {dataIdadeAlunos.map((item, index) => (
                    <div key={index} className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                      {item.name} : {item.value}%
                    </div>
                  ))}
                </div>
              </div>

              {/* IMC */}
              <div className="grid-item">
                <p className="home-titles-style-2">IMC</p>
                <GraficoBarraSimples dados={dataIMC} />
                <div className="legend">
                  {dataIMC.map((item, index) => (
                    <div key={index} className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                      {item.name} : {item.value}%
                    </div>
                  ))}
                </div>
              </div>

            </div>
            <div className="grid-container pad-top-20">
            <div className="grid-item grid-item-border">
                <p className="home-titles-style-2">Perfis dos alunos</p>
                <GraficoBarraSimples dados={dataPerfis} largura="300px" />
                <div className="grid-perfis">
                  <div className="legend-container">
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#0088fe" }}></span>
                      Adultos: {dataPerfis.find(item => item.name === "Adultos")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#00c49f"  }}></span>
                      Mulheres emag.: {dataPerfis.find(item => item.name === "Mulheres emag.")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#ffbb28"  }}></span>
                      Idosos: {dataPerfis.find(item => item.name === "Idosos")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#ff4242"  }}></span>
                      Gestantes: {dataPerfis.find(item => item.name === "Gestantes")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#66a3ff"  }}></span>
                      Pós-parto: {dataPerfis.find(item => item.name === "Pós-parto")?.value || 0}%
                    </div>
                  </div>
                  <div className="legend-container">
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#33d1b2" }}></span>
                      Obesos: {dataPerfis.find(item => item.name === "Obesos")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#ffd966"  }}></span>
                      Diabetes: {dataPerfis.find(item => item.name === "Diabetes")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#ff7f7f"  }}></span>
                      Hipertensão arterial: {dataPerfis.find(item => item.name === "Hipertensão arterial")?.value || 0}%
                    </div>
                    <div className="legend-item">
                      <span className="legend-color" style={{ backgroundColor: "#a12bff"  }}></span>
                      Depressão: {dataPerfis.find(item => item.name === "Depressão")?.value || 0}%
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-item">
                <p className="home-titles-style-2">Gênero</p>
                <GraficoBarraSimples dados={dataGeneros} />
                <div className="legend-container">
                  <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: "#0088fe" }}></span>
                    Homens: {dataGeneros.find(item => item.name === "Masculino")?.value || 0}%
                  </div>
                  <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: "#ff4242"  }}></span>
                    Mulheres: {dataGeneros.find(item => item.name === "Feminino")?.value || 0}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;